export function buildSearchWidgetOptions (dependencies = {}) {
  const {
    environment = process.env.NODE_ENV
  } = dependencies

  return {
    url: environment === 'development' && 'http://localhost:3000/api/sitecore/SearchApi/GetSearchResponse'
  }
}
